/* eslint-disable no-unused-vars */

import { getValue } from 'firebase/remote-config';
import { remoteConfig } from '../apis/firebase';

/**
 * Keys for Firebase Remote Config keys.
 * Can be used when calling {@link remoteConfig}'s `getValue()`
 *
 * @enum {string}
 */
const RemoteConfigKeys = {
  ExmapleKey: 'EXAMPLE_KEY',
  OnsiteInterviewThresholdInMinutes: 'ONSITE_INTERVIEW_THRESHOLD_MINUTES',
  PermanentRecruiterIds: 'PERMANENT_RECRUITER_IDS',
  ShowClockInOutW2States: 'SHOW_CLOCK_IN_OUT_W2_STATES',
};

/**
 * Utility object for accessing Firebase Remote Config values.
 * Provides type-safe methods to retrieve various configuration parameters.
 */
export const RemoteConfigUtils = {
  getExample: () => getValue(remoteConfig, RemoteConfigKeys.ExmapleKey).asNumber(),

  getOnsiteInterviewThresholdInMinutes: () =>
    getValue(remoteConfig, RemoteConfigKeys.OnsiteInterviewThresholdInMinutes).asNumber(),

  getPermanentRecruiterIds: () =>
    getValue(remoteConfig, RemoteConfigKeys.PermanentRecruiterIds).asString()?.split(','),

  getShowClockInOutW2States: () =>
    getValue(remoteConfig, RemoteConfigKeys.ShowClockInOutW2States).asString()?.split(','),
};
